import { Box } from "@chakra-ui/react";
import React from "react";
import BackgroundImage from "components/Icons/ChinaUIIcons/BackgroundImage.png";

const AuthDisplayArea = ({ children }) => {
  return (
    <Box
       w={{ base: "100%", sm: "430px" }}
        mx={"auto"}
        minH={"100vh"}
        backgroundImage={BackgroundImage}
    >
      {children}
    </Box>
  );
};

export default AuthDisplayArea;
